export const formatBits = (bits: number) => {
  const units = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ', 'ПБ'];
  const base = 1024;
  let value = bits;
  let unitIndex = 0;

  while (value >= base && unitIndex < units.length - 1) {
    value /= base;
    unitIndex++;
  }

  // Округляем до 2 знаков после запятой
  value = Math.round(value * 100) / 100;

  return `${value} ${units[unitIndex]}`;
};
